import { grey } from '@material-ui/core/colors';

export default () => ({
  section: {
    marginBottom: '1em',
    paddingTop: '1em',
  },
  listItem: { padding: 5 },
  listItemText: { marginRight: '20px' },
  listItemAction: {
    paddingRight: 5,
    right: 0,
  },
  statusList: {
    padding: 0,
    background: grey[50],
  },
});
